import { MutationTree } from 'vuex';
import { PushSubscribersState } from './types';

export const mutations: MutationTree<PushSubscribersState> = {
    pushSubscribers:(state, data) => {
        state.pushSubscribers = state.pushSubscribers.concat(data)
    },
    setSubscribers:(state, data) => {
        state.pushSubscribers = data
    },
    setSubscriberItem:(state, data) => {
        state.pushSubscriberItem = data
    },
};
